module.exports = __webpack_public_path__ + "static/icon_milano_nordovest_grigio-c2c50e818d6d1b91282337cbed96c3a3.svg";